var map = {
	"./alien.png": 618,
	"./back.svg": 347,
	"./bottomBar.png": 160,
	"./call.svg": 620,
	"./camera.svg": 632,
	"./close.svg": 674,
	"./face.svg": 123,
	"./gif.svg": 919,
	"./heart.svg": 730,
	"./location.svg": 968,
	"./mic.svg": 259,
	"./mj.png": 313,
	"./pic.svg": 402,
	"./search.svg": 794,
	"./smile.svg": 802,
	"./statusBar.png": 855,
	"./thumbup.svg": 446,
	"./video.svg": 559,
	"./write.svg": 675
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;